var map = {
	".": 2385,
	"./": 2385,
	"./TopNavigation": 1712,
	"./TopNavigation.js": 1712,
	"./images/home.svg": 4793,
	"./images/ico-magnifying-glass.svg": 4432,
	"./images/ico-tickets.svg": 2643,
	"./index": 2385,
	"./index.js": 2385,
	"./style.css": 6969
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4100;